import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-infobar',
  templateUrl: './infobar.component.html',
  styleUrls: ['./infobar.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgClass
  ]
})
export class InfobarComponent {

  @Input() public message: string = ''
  @Input() public icon: string = ''
  @Input() public color: string = ''

  constructor() { }

}
